<!--
  Ordini da firmare — Dettagli (Diakonix modal).
  Redesigned 2026-06-12 (v2.7.0, Phase 1.5 Chunk D.2).

  Drops kendo-dialog + kendo-overlay + 30+ kendo-label/kendo-textbox
  + kendo-formfield + 3 kendo-panelbar + ~50 inline styles
  (47 kendo refs total → 0).

  Layout (Diakonix modal XL pattern):
    - Backdrop full-viewport (z-index 2000 above sidebar)
    - Header: title + order N° tag + close X
    - Body: info card readonly (grid 3 cols) + accordion 3 sections
      (Prodotti / Documenti / Etichette&PDF)
    - Footer: Chiudi button
-->

@if (openedFIRMARE) {
  <div class="modal-backdrop" (click)="close()">
    <aside class="modal modal--xl" (click)="$event.stopPropagation()">

      <!-- ─── Header ─────────────────────────────────────────────── -->
      <header class="modal__header">
        <h2 class="modal__title">
          ✍️ Dettagli ordine da firmare
          @if (order?.or_order_number) {
            <span class="modal__title-tag">
              N° {{ order.or_order_number }}
            </span>
          }
        </h2>
        <button type="button" class="modal-close" (click)="close()" aria-label="Chiudi">×</button>
      </header>

      <!-- ─── Body ──────────────────────────────────────────────── -->
      <div class="modal__body">

        @if (loading) {
          <div class="loading-card">
            <div class="loading-card__spinner"></div>
            <p>Caricamento ordine…</p>
          </div>
        } @else if (!order) {
          <div class="loading-card">
            <p>Ordine non trovato.</p>
          </div>
        } @else {

          <!-- ── Info card readonly ── -->
          <section class="info-card" aria-label="Informazioni ordine">
            <header class="info-card__header">
              <h3 class="info-card__title">Informazioni ordine</h3>
            </header>

            <dl class="info-grid">
              <div class="info-field">
                <dt class="info-field__label">N° Ordine</dt>
                <dd class="info-field__value info-field__value--strong">
                  {{ order.or_order_number || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Data ordine</dt>
                <dd class="info-field__value">{{ formattedDate }}</dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">N° pezzi</dt>
                <dd class="info-field__value info-field__value--num">
                  {{ order.products?.length ?? 0 }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">N° colli</dt>
                <dd class="info-field__value info-field__value--num">
                  {{ order.boxes?.length ?? 0 }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Corriere</dt>
                <dd class="info-field__value">
                  {{ order.vs_details?.carrier_desc || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Operatore</dt>
                <dd class="info-field__value">
                  {{ order.vs_details?.ac_first_name || '' }}
                  {{ order.vs_details?.ac_last_name || '' }}
                  @if (
                    !(order.vs_details?.ac_first_name ||
                      order.vs_details?.ac_last_name)
                  ) { — }
                </dd>
              </div>

              <div class="info-field info-field--full">
                <dt class="info-field__label">Cliente</dt>
                <dd class="info-field__value">
                  {{ order.or_customer || '—' }}
                </dd>
              </div>

              <div class="info-field info-field--full">
                <dt class="info-field__label">Indirizzo</dt>
                <dd class="info-field__value">
                  {{ order.or_shipping_address || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Città</dt>
                <dd class="info-field__value">
                  {{ order.or_shipping_city || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">CAP</dt>
                <dd class="info-field__value info-field__value--num">
                  {{ order.or_shipping_zip || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Provincia</dt>
                <dd class="info-field__value">
                  {{ order.or_shipping_prov || '—' }}
                </dd>
              </div>

              <div class="info-field">
                <dt class="info-field__label">Nazione</dt>
                <dd class="info-field__value">
                  {{ order.or_shipping_country || '—' }}
                </dd>
              </div>
            </dl>
          </section>

          <!-- ── Accordion: Prodotti / Documenti / Etichette ── -->
          <section class="accordion" aria-label="Sezioni dettaglio">

            <!-- Prodotti -->
            <article class="accordion__item">
              <button
                type="button"
                class="accordion__header"
                [class.accordion__header--open]="isOpen('products')"
                (click)="toggleSection('products')"
              >
                <span class="accordion__icon">📦</span>
                <span class="accordion__title">Prodotti</span>
                <span class="accordion__count">
                  {{ order.products?.length ?? 0 }}
                </span>
                <span
                  class="accordion__chevron"
                  [class.accordion__chevron--open]="isOpen('products')"
                >▾</span>
              </button>

              @if (isOpen('products')) {
                <div class="accordion__body">
                  @if (!order.products?.length) {
                    <p class="accordion__empty">
                      Nessun prodotto associato a questo ordine.
                    </p>
                  } @else {
                    <ul class="products-list" role="list">
                      @for (
                        prod of order.products;
                        track prod.op_code + '-' + ($index)
                      ) {
                        <li class="product-row">
                          <span class="product-row__code">
                            {{ prod.op_code || '—' }}
                          </span>
                          <span class="product-row__desc">
                            {{ prod.op_description || '—' }}
                          </span>
                          <span class="product-row__qty">
                            {{ prod.op_qta ?? 0 }} pz
                          </span>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
            </article>

            <!-- Documenti -->
            <article class="accordion__item">
              <button
                type="button"
                class="accordion__header"
                [class.accordion__header--open]="isOpen('documents')"
                (click)="toggleSection('documents')"
              >
                <span class="accordion__icon">📂</span>
                <span class="accordion__title">Documenti</span>
                <span class="accordion__count">
                  {{ documents?.length ?? 0 }}
                </span>
                <span
                  class="accordion__chevron"
                  [class.accordion__chevron--open]="isOpen('documents')"
                >▾</span>
              </button>

              @if (isOpen('documents')) {
                <div class="accordion__body">
                  @if (!documents?.length) {
                    <p class="accordion__empty">
                      Nessun documento per questo ordine.
                    </p>
                  } @else {
                    <ul class="documents-list" role="list">
                      @for (
                        doc of documents;
                        track doc.td_document + '-' + ($index)
                      ) {
                        <li class="document-row">
                          <span class="document-row__icon">📄</span>
                          <span class="document-row__name">
                            {{ doc.td_document || '—' }}
                          </span>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
            </article>

            <!-- Etichette (PDFs) -->
            <article class="accordion__item">
              <button
                type="button"
                class="accordion__header"
                [class.accordion__header--open]="isOpen('labels')"
                (click)="toggleSection('labels')"
              >
                <span class="accordion__icon">🏷</span>
                <span class="accordion__title">Etichette &amp; PDF</span>
                <span class="accordion__chevron"
                  [class.accordion__chevron--open]="isOpen('labels')"
                >▾</span>
              </button>

              @if (isOpen('labels')) {
                <div class="accordion__body">
                  <div class="labels-grid">
                    @if (linkBordero) {
                      <a
                        class="label-link"
                        [href]="linkBordero"
                        target="_blank"
                        rel="noopener"
                      >
                        <span class="label-link__icon">📑</span>
                        <span class="label-link__text">
                          <span class="label-link__name">Borderò</span>
                          <span class="label-link__sub">Apri PDF</span>
                        </span>
                      </a>
                    }

                    @if (linkAllLabels) {
                      <a
                        class="label-link"
                        [href]="linkAllLabels"
                        target="_blank"
                        rel="noopener"
                      >
                        <span class="label-link__icon">🏷</span>
                        <span class="label-link__text">
                          <span class="label-link__name">Etichette colli</span>
                          <span class="label-link__sub">Apri PDF</span>
                        </span>
                      </a>
                    }

                    @if (linkCarrier) {
                      <a
                        class="label-link"
                        [href]="linkCarrier"
                        target="_blank"
                        rel="noopener"
                      >
                        <span class="label-link__icon">🚚</span>
                        <span class="label-link__text">
                          <span class="label-link__name">Etichetta corriere</span>
                          <span class="label-link__sub">Apri PDF</span>
                        </span>
                      </a>
                    }

                    @if (linkToDDT) {
                      <a
                        class="label-link"
                        [href]="linkToDDT"
                        target="_blank"
                        rel="noopener"
                      >
                        <span class="label-link__icon">📄</span>
                        <span class="label-link__text">
                          <span class="label-link__name">DDT</span>
                          <span class="label-link__sub">Apri PDF</span>
                        </span>
                      </a>
                    }

                    @if (!hasAnyPdf) {
                      <p class="accordion__empty">
                        Nessun PDF disponibile per questo ordine.
                      </p>
                    }
                  </div>
                </div>
              }
            </article>

          </section>
        }

      </div>

      <!-- ─── Footer ────────────────────────────────────────────── -->
      <footer class="modal__footer">
        <button type="button" class="btn btn--ghost" (click)="close()">
          Chiudi
        </button>
      </footer>

    </aside>
  </div>
}
